import React from 'react';

export type Step = {
  title: string;
  icon?: React.ReactNode;
  index: number;
};

interface StepperProps {
  activeStep: number;
  steps: Step[];
  currentBgColor?: string;
}

const Stepper = ({ activeStep, steps, currentBgColor }: StepperProps) => {
  const bgColor = currentBgColor || '#00a97f';

  return (
    <div className='wizard'>
      {steps.map((step) => {
        const isCurrent = step.index <= activeStep;
        const isActive = step.index === activeStep;

        return (
          <a
            key={step.index}
            className={isCurrent ? 'current ' : ''}
            style={{ backgroundColor: isCurrent ? bgColor : undefined }}
          >
            <span
              className={`badge ${
                steps.length === step.index ? 'badge-inverse' : ''
              } body-12-bold leading-[20.73px]`}
            >
              {step.title}
            </span>

            {isActive && (
              <style>{`
                  .wizard a.current::after {
                    border-right-color: ${bgColor};
                  
                  }
                `}</style>
            )}
          </a>
        );
      })}
    </div>
  );

  return null;
};

export { Stepper };
